<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div class="wizard wizard-1" id="kt_wizard_v1" data-wizard-state="step-first" data-wizard-clickable="false">
        <!--begin: Wizard Nav-->
        <div class="wizard-nav border-bottom">
          <div class="wizard-steps p-8 p-lg-10">
            <div class="wizard-step" data-wizard-type="step" data-wizard-state="current">
              <div class="wizard-label">
                <i class="wizard-icon fas fa-user-circle"></i>
                <h3 class="wizard-title">1. اطلاعات کاربری</h3>
              </div>
              <i class="wizard-arrow flaticon2-back"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon far fa-credit-card"></i>
                <h3 class="wizard-title">2. تایید تلفن ثابت</h3>
              </div>
              <i class="wizard-arrow flaticon2-back"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon far fa-file"></i>
                <h3 class="wizard-title">3. بارگذاری فایل</h3>
              </div>
              <i class="wizard-arrow flaticon2-back"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon far fa-credit-card"></i>
                <h3 class="wizard-title">4. درخواست درگاه</h3>
              </div>
              <i class="wizard-arrow flaticon2-back"></i>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-label">
                <i class="wizard-icon far fa-credit-card"></i>
                <h3 class="wizard-title">5. پایان</h3>
              </div>
              <i class="wizard-arrow last flaticon2-back"></i>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav-->

        <!--begin: Wizard Body-->
        <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
          <div class="col-xl-11 col-xxl-11">
            <!--begin: Wizard Form-->
            <form class="form" id="kt_form">
              <!--begin: Wizard Step 1-->
              <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
                <!-- <b-modal id="modal-1" title="اطلاعیه" ok-only ok-title="فهمیدم">
                  <p class="my-4">
                    لطفا دقت داشته باشید در صورتی که پیش از این کد رهگیری
                    مالیاتی دریافت کردید، اطلاعاتی که در این بخش وارد میکنید مثل
                    کد پستی، باید منطبق بر اطلاعات ثبت شده شما در سایت سازمان
                    امور مالیاتی باشد.
                  </p>
                </b-modal> -->
                <h3 class="mb-10 font-weight-bold text-dark">
                  اطلاعات خود را وارد کنید
                </h3>

                <b-alert :show="errors.length > 0" variant="danger">
                  <p v-for="item of errors" v-bind:key="item">{{ item }}</p>
                </b-alert>
                <b-row>
                  <!-- <b-col>
                    <b-form-group
                      id="example-input-group-1"
                      label="تاریخ ثبت نام:"
                      label-for="example-input-1"
                    >
                      <b-form-input
                        id="input-4"
                        :disabled="true"
                        v-model="$v.user.created_at"
                      ></b-form-input>
                    </b-form-group>
                  </b-col> -->
                  <b-col cols="4">
                    <b-form-group id="example-input-group-1" label="نوع حساب:" label-for="example-input-1">
                      <MDDropdown v-bind:group="17" v-model="$v.user.mdid17_merchant_type.$model"></MDDropdown>
                      <b-form-invalid-feedback id="input-1-live-feedback">وارد کردن نام اجباری
                        است</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div v-if="user.mdid17_merchant_type == 1550">
                  <PersonInfo v-model="user" v-bind:validateInputswatcher="validateInputswatcher"></PersonInfo>
                </div>
                <div v-if="user.mdid17_merchant_type == 1551">
                  <CompanyInfo v-model="user" v-bind:validateInputswatcher="validateInputswatcher"></CompanyInfo>
                </div>
                <div>
                  <UserAddress v-model="user" v-bind:validateInputswatcher="validateInputswatcher"></UserAddress>
                </div>
                <div>
                  <p>
                    * در صورت داشتن پرونده مالیاتی اطلاعات یکسان وارد نمایید.
                  </p>
                </div>
              </div>
              <!--end: Wizard Step 1-->

              <!--begin: Wizard Step 3-->
              <div class="pb-5" data-wizard-type="step-content">
                <div v-if="confPhone != null && confPhone.status.id == 1522">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    <i class="far fa-check-circle icon-2x text-success"></i>
                    تایید تلفن ثابت
                  </h4>
                  <b-alert variant="success" show>تلفن ثابت شما تایید شده است</b-alert>
                </div>
                <div v-if="confPhone != null && confPhone.status.id != 1522">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    <i class="fas fa-window-close icon-2x text-danger"></i>
                    تایید تلفن ثابت
                  </h4>
                  <ConfirmationDetails v-bind:dataUpdated="refreshConfData" v-if="confPhone != null"
                    v-bind:foritem="confPhone" v-bind:afterverified="afterverified"></ConfirmationDetails>
                  <b-modal id="confirmphone" title="اخطار" ok-only ok-title="بستن">
                    <p class="my-4">برای ادامه باید تلفن ثابت را تایید کنید</p>
                  </b-modal>
                </div>
              </div>
              <!--end: Wizard Step 3-->

              <!--begin: Wizard Step 4-->
              <div class="pb-5" data-wizard-type="step-content">
                <h4 class="mb-10 font-weight-bold text-dark">
                  بارگذاری اسکن کارت ملی به همراه سلفی از شخص و کارت ملی
                </h4>
                <div v-if="confCardMelli != null">
                  <div v-if="confCardMelli.status.id == 1520">
                    <p>اسکن کارت ملی خود را در زیر بارگذاری نمایید</p>
                    <b-row>
                      <b-col>
                        <FileUploader v-model="confCardMelli.confirmCode"></FileUploader>
                      </b-col>
                      <b-col>
                        <!-- <b-button variant="primary" @click="Validate()" class="ml-3">ذخیره عکس</b-button> -->
                      </b-col>
                    </b-row>
                    <b-row v-if="
                      confCardMelli.confirmCode != null &&
                      confCardMelli.confirmCode.length > 0
                    ">
                      <b-col>
                        <b-img v-if="confCardMelliUrl" :src="confCardMelliUrl" fluid></b-img>
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                  </div>
                  <div v-if="confCardMelli.status.id == 1521">
                    <b-alert variant="warning" show>کارت ملی شما در حال تایید توسط مدیریت می باشد</b-alert>
                  </div>
                  <div v-if="confCardMelli.status.id == 1522">
                    <b-alert variant="success" show>کارت ملی شما تایید شده است</b-alert>
                  </div>
                </div>
                <hr />
                <div v-if="confSelfiMelli != null">
                  <div v-if="confSelfiMelli.status.id == 1520">
                    <p>
                      عکس با کیفیت متوسط از کارت ملی در صورتی که آن را رو به روی
                      خود گرفته اید و به صورت سلفی عکس میگیرید را در زیر
                      بارگذاری کنید
                    </p>
                    <b-row>
                      <b-col>
                        <FileUploader v-model="confSelfiMelli.confirmCode"></FileUploader>
                      </b-col>
                      <b-col>
                        <!-- <b-button variant="primary" @click="Validate()" class="ml-3">ذخیره عکس</b-button> -->
                      </b-col>
                    </b-row>
                    <b-row v-if="
                      confSelfiMelli.confirmCode != null &&
                      confSelfiMelli.confirmCode.length > 0
                    ">
                      <b-col>
                        <b-img v-if="confSelfiMelliUrl" :src="confSelfiMelliUrl" fluid></b-img>
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                  </div>
                  <div v-if="confSelfiMelli.status.id == 1521">
                    <b-alert variant="warning" show>کارت ملی شما به همراه سلفی در حال تایید توسط مدیریت می
                      باشد</b-alert>
                  </div>
                  <div v-if="confSelfiMelli.status.id == 1522">
                    <b-alert variant="success" show>کارت ملی شما به همراه سلفی تایید شده است</b-alert>
                  </div>
                </div>

                <b-modal id="confirScans" title="اخطار" ok-only ok-title="بستن">
                  <p class="my-4">
                    بارگذاری اسکن کارت ملی به همراه سلفی اجباری می باشد
                  </p>
                </b-modal>
              </div>
              <!--end: Wizard Step 4-->

              <!--begin: Wizard Step 5-->
              <div class="pb-5" data-wizard-type="step-content">
                <h4 class="mb-10 font-weight-bold text-dark">
                  ثبت اطلاعات بانکی و درخواست درگاه
                </h4>
                <b-alert :show="errorsp.length > 0" variant="danger">
                  <p v-for="item of errorsp" v-bind:key="item">{{ item }}</p>
                </b-alert>

                <div class="row">
                  <b-col sm="6" md="4">
                    <b-form-group label="نام فروشگاه:">
                      <b-form-input v-model="$v.step5.website_name.$model"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-group label="نام فروشگاه به انگلیسی:">
                      <b-form-input v-model="$v.step5.website_en_name.$model"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-group label="دسته بندی خدمات:">
                      <MDDropdown id="select_category" placeholder="دسته بندی" group="9" required
                        v-model="$v.step5.mdid9_category.$model"></MDDropdown>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-group label="نوع ارز:">
                      <MDDropdown id="select_curency" placeholder="نوع ارز" group="12" required
                        v-model="step5.mdid12_money_type" @input="onChange($event)"></MDDropdown>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="4" v-if="show_wallet">
                    <b-form-group label="انتخاب کیف پول:">
                      <b-input-group>
                        <template v-slot:append>
                          <b-button variant="success" @click="showAddNewWallet">جدید</b-button>
                        </template>
                        <b-form-select placeholder="کیف پول" :options="optionsWallet"
                          v-model="step5.wallet_id"></b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col class="col-md-4">
                    <b-form-group id="shepalink" label="آدرس وبسایت:" label-for="shepalink-input-1">
                      <b-input-group class="mt-3">
                        <template v-slot:append>
                          <b-input-group-text>
                            <strong dir="ltr">https://</strong>
                          </b-input-group-text>
                        </template>
                        <b-form-input dir="ltr" v-model="step5.website"></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-md-4">
                    <b-form-group id="shepalink" label="شماره شبا واریز وجه:" label-for="shepalink-input-1">
                      <b-input-group class="mt-3">
                        <template v-slot:append>
                          <b-button variant="success" @click="$bvModal.show('addcard-modal')">جدید</b-button>
                        </template>
                        <b-form-select :options="userCards" v-model="$v.step5.bankId.$model"
                          :class="$v.step5.bankId.$error ? 'is-invalid' : ''"></b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback">وارد کردن شماره شبا اجباری
                          است</b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                </div>
              </div>
              <!--end: Wizard Step 5 :state="validateState('address')"-->

              <!--begin: Wizard Step 5-->
              <div class="pb-5" data-wizard-type="step-content">
                <h4 class="mb-10 font-weight-bold text-dark">
                  اتمام تایید اطلاعات
                </h4>
                <p>
                  اطلاعات شما برای مدیریت ارسال شده است. پس از تایید درگاه
                  اختصاصی شما ساخته می شود و می توانید از آن استفاده کنید.
                </p>
              </div>
              <!--end: Wizard Step 5 :state="validateState('address')"-->
              <!--begin: Wizard Actions -->
              <div class="d-flex justify-content-between border-top pt-10">
                <div class="mr-2">
                  <button class="
                      btn btn-light-success
                      font-weight-bold
                      text-uppercase
                      px-9
                      py-4
                    " data-wizard-type="action-prev">
                    مرحله قبل
                  </button>
                </div>
                <div>
                  <button v-if="wizardStep == 8" class="
                      btn btn-success
                      font-weight-bold
                      text-uppercase
                      px-9
                      py-4
                      mr-3
                    " @click="nextStep">
                    رد شدن از این مرحله
                  </button>
                  <b-button @click="EndRegister" class="
                      btn btn-success
                      font-weight-bold
                      text-uppercase
                      px-9
                      py-4
                    " data-wizard-type="action-submit">پایان</b-button>
                  <button class="
                      btn btn-success
                      font-weight-bold
                      text-uppercase
                      px-9
                      py-4
                    " data-wizard-type="action-next">
                    مرحله بعد
                  </button>
                </div>
              </div>
              <!--end: Wizard Actions -->
            </form>
            <!--end: Wizard Form-->
          </div>
        </div>
        <!--end: Wizard Body-->
      </div>
    </div>
    <AddCard v-bind:afterdone="getaccounts"></AddCard>
    <!--end: Wizard-->
    <!-- start modal -->
    <b-modal ref="addwallet-modal" :title="walletModalTitle" style="justify-content: space-around"
      @ok="sendAddOrEditWalletRequest" ok-title="ذخیره" cancel-title="بازگشت">
      <b-form>
        <b-alert variant="danger" :show="AddEdit_error.length > 0">
          <p v-for="x in AddEdit_error" v-bind:key="x">{{ x }}</p>
        </b-alert>
        <b-form-group id="input_wallet_name-group-1" label="نام کیف پول: " label-for="input_wallet_name-1">
          <b-form-input id="input_wallet_name-1" required v-model="walletName" placeholder="عنوان "></b-form-input>
        </b-form-group>
        <b-form-group id="mdid12_money_type-group-1" label="واحد پولی: " label-for="mdid12_money_type-1">
          <MDDropdown type="dollar" v-bind:group="12" v-model="mdid12_money_type1"></MDDropdown>
        </b-form-group>
      </b-form>
    </b-modal>
    <!-- end modal -->
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>
<style lang="scss" scoped>
.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
</style>
<style>
.custom-select.is-valid,
.was-validated .custom-select:valid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%231BC5BD' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E") #fff no-repeat center left 2rem / calc(0.75em + 0.65rem) calc(0.75em + 0.65rem);
}

[type="number"] {
  width: 100%;
}

.v-select.vs--single.vs--searchable button svg {
  display: none;
}
</style>
<script>
import ConfirmationDetails from "./ConfirmationDetails";
import PersonInfo from "./PersonInfo";
import CompanyInfo from "./CompanyInfo";
import MDDropdown from "../../components/MDDropdown";
import VueRecaptcha from "vue-recaptcha";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import AddCard from "../BankCards/AddCard";
import { validationMixin } from "vuelidate";
import { email, required, minLength } from "vuelidate/lib/validators";
import httpHelper from "../../helpers/httpHelper";
import UserAddress from "./UserAddress";
import FileUploader from "../../components/fileUploader";
import sessionHelper from "../../helpers/sessionHelper";
import persianDate from "../../helpers/persianDate";
import { mapState } from "vuex";
import { GET_WALLETS } from "@/core/services/store/wallets.module";
import routesMap from '@/helpers/routesMap'
const numbers = (value, vm) => !/[^0-9]/.test(value);
const idnumbers = (value, vm) => {
  return parseInt(value) != 0;
};
let wizard = null;
var vm = {
  mixins: [validationMixin],
  name: "Wizard-1",
  components: {
    AddCard,
    "vue-recaptcha": VueRecaptcha,
    PersonInfo,
    CompanyInfo,
    MDDropdown,
    ConfirmationDetails,
    UserAddress,
    FileUploader,
  },
  data() {
    return {
      wizardStep: 0,
      userCards: {},
      errors: [],
      errorsp: [],
      userConf: [],
      validateInputswatcher: null,
      user: {
        name: "",
        email: "",
        fa_name: "",
        fa_family: "",
        fa_father: "",
        en_name: "",
        en_family: "",
        en_father: "",
        mobile: "",
        name: "",
        phone: "",
        postalCode: "",
        national_card_number: "",
        id_number: "",
        merchant_type: 0,
        pre_phone: "",
        business_license: "",
        en_company_name: "",
        register_number: "",
      },
      step5: {
        website: "",
        bankId: "",
        taxpayercode: "",
        website_name: "",
        website_en_name: "",
        mdid9_category: "",
        mdid12_money_type: "",
      },
      Loading: false,
      confMobile: null,
      confPhone: null,
      confCardMelli: null,
      confSelfiMelli: null,
      refreshConfData: null,
      optionsWallet: [],
      show_wallet: false,
      walletModalTitle: null,
      wallet_id: null,
      AddEdit_error: [],
      walletName: null,
      mdid12_money_type1: null,
      confCardMelliUrl: "",
      confSelfiMelliUrl: "",
      routesMap,
    };
  },
  computed: {
    loadedWallets() {
      return this.$store.getters.loadedWallets;
    },
  },
  watch: {
    "confSelfiMelli.confirmCode"(newVal) {
      httpHelper
        .getImage(newVal)
        .then((res) => {
          this.confSelfiMelliUrl = res?.result?.url || "";
        })
    },
    "confCardMelli.confirmCode"(newVal) {
      httpHelper
        .getImage(newVal)
        .then((res) => {
          this.confCardMelliUrl = res?.result?.url || "";
        })
    },
    userCards(neww, old) {
      if (neww.length != 0) {
        this.step5.bankId = neww.at(-1).value;
      }
    },
  },
  validations: {
    user: {
      email: {
        required,
        email,
      },
      fa_name: {
        required,
      },
      fa_family: {
        required,
      },
      national_card_number: {
        required,
      },
      id_number: {
        required,
        minLength: minLength(1),
      },
      mobile: {
        required,
      },
      mdid17_merchant_type: {
        required,
      },
      fa_father: {},
      mdid4_province: {
        required,
      },
      mdid5_city: {
        required,
      },
      address: {
        required,
        minLength: minLength(10),
      },
      postalCode: {
        required,
        minLength: minLength(10),
      },
      // register_number: {
      //   required,
      //   minLength: minLength(4),
      //   numbers
      // }
    },
    step5: {
      taxpayercode: {},
      bankId: {
        required,
      },
      website_name: { required },
      website_en_name: { required },
      mdid9_category: { required },
    },
  },
  mounted() {
    // this.$bvModal.show("modal-1");
    let api = "wallets";
    this.$store.dispatch(GET_WALLETS, api);

    this.getUserData();
    let self = this;

    // Initialize form wizard
    wizard = new KTWizard("kt_wizard_v1", {
      startStep: 1, // initial active step number
      clickableSteps: false, // allow step clicking,
    });
    //wizard.goTo(5);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "مرحله " + wizard.getStep() },
      { title: "تایید اطلاعات کاربری" },
    ]);
    // Validation before going to next page
    wizard.on("beforeNext", function (wizardObj) {
      wizardObj.stop();

      if (wizardObj.getStep() == 1) {
        self.$v.user.$touch();
        if (self.$v.user.$anyError) {
          self.validateInputswatcher = Math.ceil(Math.random() * 100) + 1;
          return;
        }
        // if (self.$v.user.$anyError) {
        //   self.validateState();
        //   return;
        // } else {

        // }
        wizardObj.btnNext.classList.add(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        self.saveUserData();
      }
      // else if (wizardObj.getStep() == 2) {
      //   if (self.confMobile.status.id == 1522) {
      //     wizardObj.goNext();
      //   } else {
      //     self.$bvModal.show("confirmMobile");
      //   }
      // }
      else if (wizardObj.getStep() == 2) {
        if (self.confPhone.status.id == 1522) {
          wizardObj.goNext();
        } else {
          self.$bvModal.show("confirmphone");
        }
      } else if (wizardObj.getStep() == 3) {
        if (
          self.confCardMelli.status.id >= 1521 &&
          self.confSelfiMelli.status.id >= 1521
        ) {
          self.wizardStep = 8;

          wizardObj.goNext();
        } else if (
          (self.confCardMelli.status.id == 1520 &&
            self.confCardMelli.confirmCode != null &&
            self.confCardMelli.confirmCode.length > 0) ||
          (self.confSelfiMelli.status.id == 1520 &&
            self.confSelfiMelli.confirmCode != null &&
            self.confSelfiMelli.confirmCode.length > 0)
        ) {
          self.ValidateCardMelli();
        } else {
          self.$bvModal.show("confirScans");
        }
      } else if (wizardObj.getStep() == 4) {
        self.$v.step5.$touch();
        if (self.$v.step5.$anyError) {
          //self.validateInputswatcher = Math.ceil(Math.random() * 100) + 1;
          return;
        }
        httpHelper.postData("userconf/bandp", self.step5).then((res) => {
          if (res.success == true) {
            wizardObj.goNext();
          } else {
            self.errorsp = [];
            for (var key in res.error) {
              res.error[key].forEach((element) => {
                self.errorsp.push(element);
              });
            }
          }
        });
      } else {
        wizardObj.goNext();
      }
    });
    // Change event
    wizard.on("change", function (wizardObj) {
      self.$store.dispatch(SET_BREADCRUMB, [
        { title: "مرحله " + wizardObj.getStep() },
        { title: "تایید اطلاعات کاربری" },
      ]);
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },

  methods: {
    ValidateCardMelli() {
      if (this.confCardMelli.confirmCode != null)
        httpHelper
          .postData("userconf/validate", this.confCardMelli)
          .then((res) => {
            this.submitLoading = false;
            if (res.success) {
              if (res.result == true) {
                //this.$bvModal.hide("confirmationModal");
                this.afterverified();
                this.timer = 0;
              } else {
                this.errors.push("کد وارد شده صحیح نمی باشد");
              }
            }
          });
      if (this.confSelfiMelli.confirmCode != null)
        httpHelper
          .postData("userconf/validate", this.confSelfiMelli)
          .then((res) => {
            this.submitLoading = false;
            if (res.success) {
              if (res.result == true) {
                //this.$bvModal.hide("confirmationModal");
                this.SelfiMeliUploaded();
                this.afterverified();
                this.timer = 0;
              } else {
                this.errors.push("کد وارد شده صحیح نمی باشد");
              }
            }
          });
    },
    afterverified() {
      httpHelper.setAuth();
      httpHelper
        .getData("userconf")
        .then((res) => {
          this.userConf = res.result;
          this.userConf.forEach((element) => {
            if (element.type.id == 1501) {
              this.confMobile = element;
            } else if (element.type.id == 1503) {
              this.confPhone = element;
            } else if (element.type.id == 1506) {
              this.confCardMelli = element;
            } else if (element.type.id == 1505) {
              this.confSelfiMelli = element;
            }
          });
        })
        .finally(() => { });
      // wizard.goNext();
      // self.wizardStep = wizard.getStep();
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "مرحله " + wizard.getStep() },
        { title: "تایید اطلاعات کاربری" },
      ]);
    },
    kartMeliUploaded() {
      this.confCardMelli.status.id = 1521;
    },
    SelfiMeliUploaded() {
      this.confSelfiMelli.status.id = 1521;
    },
    getUserData() {
      httpHelper.getData("users/verify").then((res) => {
        this.user = {
          name: res.name,
          email: res.email,
          fa_name: res.fa_name,
          fa_family: res.fa_family,
          fa_father: res.fa_father,
          en_name: res.en_name,
          en_family: res.en_family,
          en_father: res.en_father,
          mobile: res.mobile,
          name: res.name,
          phone: res.phone,
          pre_phone: res.pre_phone,
          postalCode: res.postalCode,
          national_card_number: res.national_card_number,
          mdid17_merchant_type: res.mdid17_merchant_type,
          mdid18_gender: res.mdid18_gender,
          mdid4_province: res.mdid4_province,
          mdid5_city: res.mdid5_city,
          address: res.address,
          com_shenase: res.com_shenase,
          birth_date: persianDate.getDateByFormat(new Date(res.birth_date)),
          business_license: res.business_license,
          en_company_name: res.en_company_name,
          id_number: res.id_number,
          register_number: res.register_number,
          register_date: res.register_date,
        };
        if (this.user.created_at != null) {
          this.user.created_at = persianDate.getDateByFormat();
        } else {
          this.user.created_at = "-";
        }
        if (
          res.phonestatus != 1520 &&
          res.nationalstatus != 1520 &&
          res.selfiestatus != 1520
        ) {
          this.$router.push("/dashboard");
        }
        this.getaccounts();
      });
    },
    getaccounts() {
      this.step5.shepalink = this.user.mobile;
      httpHelper.getData("usercards").then((response) => {
        this.userCards = response.result.map((item) => {
          return {
            text: item.shaba_number,
            value: item.id,
          };
        });
      });
    },
    saveUserData() {
      httpHelper.postData("users", this.user).then((res) => {
        wizard.btnNext.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        if (res.success == false) {
          this.errors = [];
          for (const key in res.error) {
            if (res.error.hasOwnProperty(key)) {
              const element = res.error[key];
              this.errors.push(element[0]);
            }
          }
          return;
        }

        httpHelper.setAuth();
        httpHelper
          .getData("userconf")
          .then((res) => {
            this.refreshConfData = Math.ceil(Math.random() * 100) + 1;
            this.userConf = res.result;
            this.userConf.forEach((element) => {
              if (element.type.id == 1501) {
                this.confMobile = element;
              } else if (element.type.id == 1503) {
                this.confPhone = element;
              } else if (element.type.id == 1506) {
                this.confCardMelli = element;
              } else if (element.type.id == 1505) {
                this.confSelfiMelli = element;
              }
            });
          })
          .finally(() => { });
        wizard.goNext();
        this.$store.dispatch(SET_BREADCRUMB, [
          { title: "مرحله " + wizard.getStep() },
          { title: "تایید اطلاعات کاربری" },
        ]);
        this.$makeToast(
          "success",
          "تایید اطلاعات",
          "اطلاعات شما با موفقیت ثبت شد.",
          5000
        );
        // this.$bvToast.toast("اطلاعات شما با موفقیت ثبت شد", {
        //   title: "تایید اطلاعات",
        //   variant: "success",
        //   solid: true,
        // });
      });
    },
    checkStepOne() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return false;
      }
      return true;
    },
    onVerify: function (response) {
      if (response) {
        this.form.robot = true;
        this.form.captcha = response;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    EndRegister() {
      this.$router.go(0);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.step5[name];
      return $dirty ? !$error : null;
    },
    validateInputs() {
      this.$v.step5.$touch();
    },
    nextStep() {
      this.wizardStep++;
      wizard.goNext();
    },
    onChange(e) {
      if (e == 483) {
        this.show_wallet = false;
        this.optionsWallet = [];
      } else {
        this.show_wallet = true;
        this.createOption(this.loadedWallets);
      }
    },
    createOption(option) {
      option = option.filter((v) => v.md12_title === "دلار");
      this.optionsWallet = [];
      let opt = {};
      option.forEach((element) => {
        Object.assign(opt, { value: element.id, text: element.wallet_name });
        this.optionsWallet.push(opt);
        opt = {};
      });
    },
    showAddNewWallet: function () {
      this.walletModalTitle = "اضافه کردن کیف پول جدید";
      this.showWalletModal();
    },
    showWalletModal() {
      this.$refs["addwallet-modal"].show();
    },
    sendAddOrEditWalletRequest(event) {
      event.preventDefault();
      if (this.loading) {
        return;
      }
      if (this.walletName == "" || this.walletName == null) {
        this.AddEdit_error.push("نام کیف پول را وارد کنید");
        return;
      }
      this.loading = true;
      httpHelper.setAuth();

      let walletData = {
        wallet_name: this.walletName,
        mdid12_money_type: this.mdid12_money_type1,
      };

      if (this.isInEditMode) walletData.id = this.walletId;

      httpHelper.postData("wallets", walletData).then((response) => {
        if (response.success === true) {
          httpHelper
            .getData("wallets")
            .then((response) => {
              this.createOption(response.result);
              this.hideWalletModal();
              this.loading = false;
            })
            .finally(() => { });
        }
      });
    },
    hideWalletModal: function () {
      this.$refs["addwallet-modal"].hide();
    },
  },
};
export default vm;
</script>
